import { Link } from "react-router-dom";

export default function SectionHeading({
  eyebrow,
  title,
  description,
  action,
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: { to: string; label: string };
}) {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="max-w-2xl">
        {eyebrow && (
          <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.24em] text-primary-600">
            <span className="h-1 w-1 rounded-full bg-primary-500" />
            {eyebrow}
          </span>
        )}
        <h2 className="mt-2.5 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {description && (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {description}
          </p>
        )}
      </div>
      {action && (
        <Link
          to={action.to}
          className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          {action.label}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}